import { createTheme } from '@mui/material';
import { red } from '@mui/material/colors';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const fontFamily = 'Poppins';

const _dark = clientThemePalette[CLIENT_THEME].dark;
const _light = clientThemePalette[CLIENT_THEME].light;

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: _light.primary,
    },
    secondary: {
      main: _light.primary,
    },
    error: {
      main: red.A400,
    },
    background: {
      default: _light.pageBackground,
      paper: _light.menuOptions,
    },
    text: {
      primary: '#111111',
      secondary: '#555555',
    },
    svgIcons: {
      primary: { fill: _light.primary },
      error: { fill: '#A03434' },
    },
  },
  typography: {
    fontFamily,
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: _dark.primary,
    },
    secondary: {
      main: _dark.primary,
    },
    error: {
      main: red.A400,
    },
    background: {
      default: _dark.toolBarBackground,
      paper: _dark.modalBackground,
    },
    text: {
      primary: '#E2E8F0',
      secondary: '#A0AEC0',
    },
    svgIcons: {
      primary: { fill: _dark.primary },
      error: { fill: '#A03434' },
    },
  },
  typography: {
    fontFamily,
  },
  components: {},
});

export const myVar = '';
